'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const PrefetchData = ({
  children
}) => {
  const {
    loading: themeLoading
  } = nthHookTheme.useThemeX();
  const {
    loading: translationsLoading
  } = nthHookTranslations.useTranslationsX();
  if (translationsLoading || themeLoading) return null;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, children);
};
var PrefetchData$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(PrefetchData, {
  themeTokens: ['bodytextDefaultNone', 'buttonsPrimaryDefault', 'buttonsPrimaryDisabled', 'buttonsPrimaryHover', 'buttonsSecondaryDefault', 'buttonsSecondaryDisabled', 'buttonsSecondaryHover', 'headersSemibigNone', 'headersMediumNone', 'panelcontainerNoneNone', 'panelbodyNoneNone', 'panelheaderNoneNone']
}), {
  translationKeys: ['shipmentsPanelHeader', 'shipmentsButton', 'shipmentsItemLabel', 'packShipmentsDateTokenOrder']
});

exports["default"] = PrefetchData$1;
